import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-6">서비스 소개</h1>
      
      {/* 서비스 개요 */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">AI 기반 업무 자동화 서비스</h2>
        <p className="text-gray-600 leading-relaxed">
          FairNex는 AI 기술을 활용하여 다양한 업무를 자동화하고 효율화하는 서비스입니다.
          PDF 문서 분석부터 운세 상담까지, AI 비서와 함께 더 스마트한 업무 환경을 만들어보세요.
        </p>
      </section>

      {/* 주요 서비스 */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-6">주요 서비스</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="p-6 bg-white rounded-lg shadow-sm">
            <h3 className="text-xl font-semibold mb-3 flex items-center">
              <span className="mr-2">📄</span>
              PDF 문서 분석
            </h3>
            <p className="text-gray-600">
              AI가 PDF 문서를 분석하여 핵심 내용을 추출하고 요약합니다. 
              일반, 비즈니스, 기술 등 다양한 관점의 분석이 가능합니다.
            </p>
          </div>
          <div className="p-6 bg-white rounded-lg shadow-sm">
            <h3 className="text-xl font-semibold mb-3 flex items-center">
              <span className="mr-2">🔮</span>
              운세 상담
            </h3>
            <p className="text-gray-600">
              AI가 사주와 운세를 분석하여 맞춤형 상담을 제공합니다.
              개인의 운세와 성향을 고려한 조언을 받아보세요.
            </p>
          </div>
        </div>
      </section>

      {/* 서비스 특징 */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-6">서비스 특징</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="p-6 bg-white rounded-lg shadow-sm">
            <h3 className="text-xl font-semibold mb-3 flex items-center">
              <span className="mr-2">🎯</span>
              맞춤형 분석
            </h3>
            <p className="text-gray-600">
              각 서비스별로 사용자의 요구사항에 맞는 맞춤형 분석과 결과를 제공합니다.
            </p>
          </div>
          <div className="p-6 bg-white rounded-lg shadow-sm">
            <h3 className="text-xl font-semibold mb-3 flex items-center">
              <span className="mr-2">⚡️</span>
              빠른 처리
            </h3>
            <p className="text-gray-600">
              최신 AI 기술을 활용하여 빠르고 정확한 결과를 제공합니다.
            </p>
          </div>
          <div className="p-6 bg-white rounded-lg shadow-sm">
            <h3 className="text-xl font-semibold mb-3 flex items-center">
              <span className="mr-2">💡</span>
              스마트 자동화
            </h3>
            <p className="text-gray-600">
              반복적인 업무를 자동화하여 업무 효율성을 높입니다.
            </p>
          </div>
          <div className="p-6 bg-white rounded-lg shadow-sm">
            <h3 className="text-xl font-semibold mb-3 flex items-center">
              <span className="mr-2">🔒</span>
              안전한 처리
            </h3>
            <p className="text-gray-600">
              모든 데이터는 안전하게 처리되며, 개인정보를 철저히 보호합니다.
            </p>
          </div>
        </div>
      </section>

      {/* 활용 분야 */}
      <section className="mb-12">
        <h2 className="text-2xl font-semibold mb-6">활용 분야</h2>
        <div className="bg-white rounded-lg shadow-sm p-6">
          <ul className="space-y-4">
            <li className="flex items-center">
              <span className="mr-3 text-xl">💼</span>
              <div>
                <h4 className="font-semibold">비즈니스 업무</h4>
                <p className="text-gray-600">문서 분석, 보고서 작성, 데이터 처리 등 업무 자동화</p>
              </div>
            </li>
            <li className="flex items-center">
              <span className="mr-3 text-xl">🎯</span>
              <div>
                <h4 className="font-semibold">개인 상담</h4>
                <p className="text-gray-600">운세 상담, 성향 분석, 진로 상담 등 맞춤형 조언</p>
              </div>
            </li>
            <li className="flex items-center">
              <span className="mr-3 text-xl">📊</span>
              <div>
                <h4 className="font-semibold">데이터 분석</h4>
                <p className="text-gray-600">문서 요약, 데이터 추출, 인사이트 도출</p>
              </div>
            </li>
          </ul>
        </div>
      </section>

      {/* 시작하기 버튼 */}
      <div className="text-center">
        <Link
          to="/services"
          className="inline-block px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors duration-200"
        >
          FairNex 시작하기
        </Link>
      </div>
    </div>
  );
};

export default About;